import React, { useEffect, useState, useRef } from "react";
import {
  Table,
  Badge,
  Button,
  Modal,
  Spinner,
  ListGroup,
} from "react-bootstrap";
import styles from "./ComplaintList.module.css";
import { formatDateTime } from "../../../utils/formatters";
import UserInformation from "../../Users/UserInformation/UserInfromation";
import { complaintService } from "../../../services/complaintService";

const statusColor = (status) => {
  switch (status) {
    case "new":
      return "success";
    case "pending":
      return "warning";
    case "closed":
      return "dark";
    default:
      return "danger";
  }
};
const statusTranslate = (status) => {
  switch (status) {
    case "new":
      return "Новая";
    case "pending":
      return "В работе";
    case "closed":
      return "Закрыта";
    default:
      return status;
  }
};
const typeTranslate = (status) => {
  switch (status) {
    case "other":
      return "Другое";
    case "spam":
      return "Спам";
    case "content":
      return "Непримелимый контент";
    default:
      return status;
  }
};

const ComplaintList = ({ complaints, onAction }) => {
  const [selected, setSelected] = useState(null);
  const [participantsChat, setParticipantsChat] = useState(null);
  const [chatLoading, setChatLoading] = useState(false);
  const bottomRef = useRef(null);

  const handleView = (complaint) => {
    setSelected(complaint);
  };

  const handleModalClose = () => setSelected(null);

  const handleAction = (status, extra = {}) => {
    if (!selected) return;
    onAction?.(selected, { status, ...extra });
    setSelected(null);
  };

  useEffect(() => {
    let cancelled = false;
    const load = async () => {
      if (!selected?.creatorId || !selected?.targetId) return;
      setChatLoading(true);
      try {
        const data = await complaintService.getParticipantsChat({
          creatorId: selected.creatorId,
          targetId: selected.targetId,
        });
        if (!cancelled) setParticipantsChat(data || null);
      } finally {
        if (!cancelled) setChatLoading(false);
      }
    };
    setParticipantsChat(null);
    load();
    return () => {
      cancelled = true;
    };
  }, [selected]);

  useEffect(() => {
    if (bottomRef.current) {
      bottomRef.current.scrollIntoView({ behavior: "smooth" });
    }
  }, [participantsChat?.messages?.length]);

  return (
    <>
      <div className={styles.tableWrapper}>
        <Table responsive hover size="sm">
          <thead>
            <tr>
              <th>ID</th>
              {/* <th>Кто пожаловался</th>
              <th>На кого</th> */}
              <th>Тип</th>
              <th>Причина</th>
              <th>Дата</th>
              <th>Статус</th>
              <th />
            </tr>
          </thead>
          <tbody>
            {complaints.map((c) => {
              return (
                <tr key={c._id}>
                  <td>{c._id}</td>
                  {/* <td>{c.creatorId}</td>
                  <td>{c.targetId}</td> */}
                  <td>
                    <Badge bg="info">{typeTranslate(c.type)}</Badge>
                  </td>
                  <td className={styles.reason}>{c.message}</td>
                  <td>{formatDateTime(c.createdAt)}</td>
                  <td>
                    <Badge bg={statusColor(c.status)}>
                      {statusTranslate(c.status)}
                    </Badge>
                  </td>
                  <td className="text-end">
                    <Button
                      size="sm"
                      variant="outline-primary"
                      onClick={() => handleView(c)}
                    >
                      Просмотр
                    </Button>
                  </td>
                </tr>
              );
            })}
            {complaints.length === 0 && (
              <tr>
                <td colSpan={8} className="text-center text-muted py-3">
                  Жалоб нет
                </td>
              </tr>
            )}
          </tbody>
        </Table>
      </div>

      <Modal
        show={Boolean(selected)}
        onHide={handleModalClose}
        size="lg"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Детали жалобы</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {selected && (
            <>
              <p className="mb-1">
                <strong>ID жалобы:</strong> {selected._id}
              </p>
              <p className="mb-1">
                <strong>Тип:</strong> {selected.type}
              </p>
              <p className="mb-1">
                <strong>Статус:</strong> {selected.status}
              </p>
              <p className="mb-1">
                <strong>Причина:</strong> {selected.message || "—"}
              </p>
              <p className="mb-1">
                <strong>Создано:</strong> {formatDateTime(selected.createdAt)}
              </p>
              <p className="mb-1">
                <strong>Кто пожаловался:</strong> {selected.creatorId}
              </p>
              <UserInformation userId={selected.creatorId} />
              <p className="mt-2 mb-1">
                <strong>На кого пожаловались:</strong> {selected.targetId}
              </p>
              <UserInformation userId={selected.targetId} />

              <hr />
              <p className="mt-1 mb-1">
                <strong>Чат между участниками жалобы</strong>
              </p>
              {chatLoading ? (
                <div className="d-flex justify-content-center py-2">
                  <Spinner animation="border" size="sm" />
                </div>
              ) : participantsChat?.chatId &&
                (participantsChat?.messages || []).length ? (
                <div
                  style={{
                    maxHeight: 220,
                    minHeight: 120,
                    overflowY: "auto",
                    border: "1px solid #eee",
                    borderRadius: 8,
                    padding: 8,
                    background: "#fafafa",
                  }}
                >
                  <ListGroup variant="flush" className="small">
                    {(participantsChat.messages || []).map((m) => {
                      const isCreator =
                        participantsChat.creatorChatId &&
                        m.user_id === participantsChat.creatorChatId;
                      const label = isCreator ? "Автор жалобы" : "Участник";
                      const sender = m.User || m.user || {};
                      return (
                        <ListGroup.Item
                          key={m.message_id}
                          className="py-1 px-2"
                          style={{
                            border: "none",
                            textAlign: isCreator ? "left" : "right",
                          }}
                        >
                          <div
                            className={`d-inline-block px-2 py-1 rounded ${
                              isCreator ? "bg-light" : "bg-primary text-white"
                            }`}
                          >
                            <div className="small mb-1">
                              {sender?.name || sender?.username || label}
                            </div>
                            <div>
                              {m.message_type === "call" ? "Звонок" : m.content}
                            </div>
                          </div>
                        </ListGroup.Item>
                      );
                    })}
                    <div ref={bottomRef} />
                  </ListGroup>
                </div>
              ) : (
                <div className="text-muted small">
                  Приватный чат между участниками не найден или сообщений нет.
                </div>
              )}
            </>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleModalClose}>
            Закрыть
          </Button>
          <Button
            variant="outline-success"
            onClick={() => handleAction("closed")}
          >
            Закрыть жалобу
          </Button>
          <Button
            variant="outline-warning"
            onClick={() => handleAction("pending")}
          >
            В обработке
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default ComplaintList;
